<template>
  <div class="flex flex-wrap vz-specific-loading-review">
    <div
      v-for="item of computedItems"
      class="color-light text-caption vz-specific-loading-review-badge"
    >
      <span>{{ item.title }}</span>
      <vz-close-btn
        class="close-btn"
        :width="20"
        :height="20"
        :size="14"
        @click="emit('remove', item.code)"
      />
    </div>
    <vz-specific-loading-modal
      :direction-to="directionTo"
      @save="emit('save', $event)"
    />
  </div>
</template>

<script setup lang="ts">
import VzCloseBtn from '@/components/ui-kit/vz-close-btn.vue';
import {PropType} from 'vue';
import VzSpecificLoadingModal from '@/components/modals/vz-specific-loading/vz-specific-loading-modal.vue';
import {useSpecificLoadingStore} from '~/stores/specific-loading';

const emit = defineEmits(['remove', 'save'])

const props = defineProps({
  items: {
    type: Array as PropType<{ code: string }[]>,
    default: () => ([])
  },
  directionTo: {
    type: Boolean,
    default: false
  }
})

const { getSpecificLoadingByCode } = useSpecificLoadingStore()

const computedItems = computed(() => {
  return props.items.map(item => {
    const specificLoadingItem = getSpecificLoadingByCode(item.code)
    return {
      code: item.code,
      title: specificLoadingItem.name
    }
  })
})
</script>
